<template>
    <section class='fixed-titles'>
        <div class='title-top'>
            <h2 ref='titleTop'/>
            <span ref='titleIp'>{{fixedTitleIp}}</span>
        </div>
        <div class='title-left'>
            <h2 v-show='fixedTitleLeft.length > 0' ref='titleLeft'>{{fixedTitleLeft}}</h2>
        </div>
        <div class='slide-count'>
            <span ref='slideCount' v-show='fixedSlideCount.length > 0'>{{fixedSlideCount}}</span>
        </div>
    </section>
</template>

<script>
import { TweenMax } from 'gsap'
import '@/scripts/gsap.ScrambleTextPlugin'

export default {
    props: {
        fixedTitleTop: String,
        fixedTitleIp: String,
        fixedTitleLeft: String,
        fixedSlideCount: String
    },
    watch: {
        fixedTitleTop(val, oldVal) {
            TweenMax.fromTo(this.$refs.titleTop, 0.5, { scrambleText: oldVal }, { scrambleText: val })
        },
        fixedTitleIp(val, oldVal) {
            TweenMax.fromTo(this.$refs.titleIp, 0.5, {scrambleText: oldVal }, { scrambleText: val, revealDelay: 0.5 })
        },
        fixedTitleLeft(val, oldVal) {
            TweenMax.fromTo(this.$refs.titleLeft, 0.5, { scrambleText: oldVal }, { scrambleText: val })
        }
    }
}
</script>

<style lang='scss' scoped>

@import './../styles/mixins';
@import './../styles/vars';

.fixed-titles {
    position: fixed;
    top: 0; right: 0; bottom: 0; left: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    user-select: none;
    pointer-events: none;
    letter-spacing: 0.25em;
    z-index: 3;
    .title-top {
        position: absolute;
        top: 0; left: vw(180);
        height: vw(90);
        display: flex;
        align-items: center;
        h2 {
            margin-right: vw(10);
        }
    }
    .title-left {  
        width: vw(90);
        writing-mode: tb;
        align-items: center;
        display: flex;
        height: 100%;
        justify-content: center;
    }
    .slide-count {
        position: absolute;
        bottom: 0; left: vw(180);
        height: vw(90);
        display: flex;
        align-items: center;
    }
    h2, span {
        @include fluid-type(8px, 16px);
        text-transform: uppercase;
        white-space: nowrap;
        display: flex;
    }

    h2 {
        font-family: $font-bold-headline;
    }
    span {
        font-family: $font-light-headline;
    }
}
</style>
